import { render, staticRenderFns } from "./IndicadoresFields.vue?vue&type=template&id=5da4e22b&"
import script from "./IndicadoresFields.vue?vue&type=script&lang=js&"
export * from "./IndicadoresFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports